import { render, staticRenderFns } from "./PublishControls.vue?vue&type=template&id=aee95402"
import script from "./PublishControls.vue?vue&type=script&lang=js"
export * from "./PublishControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports